import React from 'react';
import { Navigate } from 'react-router';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import {
  PRODUCT_SWITCH_RESTRICTION_MESSAGE,
  PRODUCT_SWITCH_RESTRICTION_TITLE,
} from 'constants/messages/productSwitch';
import { consumeProductSwitchPending } from 'utils/CrossTabProductSwitch';

interface GuardedRouteProps {
  component: React.JSX.Element;
  isAllowed: boolean;
  redirectTo?: string;
  message?: string;
  snackbarType?: EAlertType;
  snackbarPosition?: ESnackBarPosition;
  [key: string]: any; // for Route props like path, exact, etc.
}

const GuardedRoute: React.FC<GuardedRouteProps> = ({
  component: Component,
  isAllowed,
  redirectTo = '/',
  message,
  snackbarType = EAlertType.ERROR,
  snackbarPosition = ESnackBarPosition.TOP,
}) => {
  if (isAllowed) {
    return Component;
  }

  if (consumeProductSwitchPending()) {
    showAlertSnackBar(
      EAlertType.WARNING,
      snackbarPosition,
      PRODUCT_SWITCH_RESTRICTION_MESSAGE,
      PRODUCT_SWITCH_RESTRICTION_TITLE,
    );
  } else if (message) {
    showAlertSnackBar(snackbarType, snackbarPosition, message);
  }
  return <Navigate to={redirectTo} replace />;
};

export default GuardedRoute;
